import React from 'react';
import classes from "./MenuIdeasTitle.module.scss";

const MenuIdeasTitle = (props) => {
    return (
        <div className={classes.MenuIdea_title}>
            <div>{props.title}</div>
        </div>
    );
}

export default MenuIdeasTitle;